module.exports = __webpack_public_path__ + "static/media/footwear.ed2b3d7f.png";